import { Suspense, lazy } from 'react';
import { RequireAuth } from '@/lib/auth/RequireAuth';
import { Loader } from '@/components/Loader';

// MARS forecasts / expected returns. Lazy-loaded: three Plotly-heavy tabs
// stay out of the main chunk.
const MarsForecastsPage = lazy(() => import('@/features/mars/forecasts/MarsForecastsPage'));

export function MarsForecastsRoute(): JSX.Element {
  return (
    <RequireAuth>
      <Suspense fallback={<Loader label="Loading" />}>
        <MarsForecastsPage />
      </Suspense>
    </RequireAuth>
  );
}
